import { Icon, IconProps } from "../";

export const PartiallySupportedIcon = (props: IconProps) => {
  return (
    <Icon {...props}>
      <path
        fillRule="evenodd"
        d="M100,1199.77 L106.39,1210 L93.61,1210 L100,1199.77 M99.15,1197.36 L90.95,1210.47 C90.54,1211.14 91.02,1212 91.8,1212 L108.2,1212 C108.99,1212 109.46,1211.14 109.05,1210.47 L100.85,1197.36 C100.46,1196.73 99.54,1196.73 99.15,1197.36 Z"
        transform="translate(-88 -1192)"
      />
    </Icon>
  );
};
